import type { ApiPick, ApiScoringEvent } from "../../../../../api/index.ts";

export function getEventPoints(
  scoringEvent: ApiScoringEvent,
  picks: ApiPick[],
) {
  const pick = picks.find((p) => p.id === scoringEvent.gameEventId);

  const powerupPoints = pick?.powerupPoints || 0;

  return {
    base: scoringEvent.gameEvent.points,
    powerup: powerupPoints,
    total: scoringEvent.gameEvent.points + powerupPoints,
  };
}
